/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Whats_New_Category_SecurityInputs */

const vi_whats_new_category_security = /** @type {(inputs: Whats_New_Category_SecurityInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bảo mật`)
};

/**

* @param {Whats_New_Category_SecurityInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const whats_new_category_security = /** @type {((inputs?: Whats_New_Category_SecurityInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Whats_New_Category_SecurityInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_whats_new_category_security(inputs)
});